import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { SavedAudiencesQuery, SavedAudiencesQueryVariables } from './__generated__/SavedAudiencesQuery';

export const SAVED_AUDIENCES_QUERY = gql`
  query SavedAudiencesQuery($accountId: ID!, $search: String!) {
    savedAudiences(accountId: $accountId, search: $search)
  }
`;

export const useSavedAudiencesLazyQuery = () => {
  return useLazyQuery<SavedAudiencesQuery, SavedAudiencesQueryVariables>(SAVED_AUDIENCES_QUERY, {
    client: kmsClient,
    fetchPolicy: 'cache-first'
  });
};
